import ApiService from "../../helpers/ApiHelper";

class BookingService {


    static getBookings(payload) {
        const params = new URLSearchParams({
            page: payload.page,
            typeStatus: payload.bookingsType,
            pageSize: payload.pageSize,
        });

        const { search, q } = payload;
        // Only append the search parameter if there are active filters.
        // This prevents simple page changes from being treated as new searches.
        if (search && (search.text || (search.tagsFilters && Object.keys(search.tagsFilters).length > 0) || search.searchInArchive)) {
            params.append('search', JSON.stringify(search));
        }
        if (q) {
            params.append('q', q);
        }

        return ApiService.request(
          `/api/v1/bookings/?${params.toString()}`,
          "get",
          null
        )
    }

}

export default BookingService;
